import { Button } from "react-bootstrap";

const CategoriesHeader = ({
  searchTerm,
  onSearchChange,
  total,
  onAddCategory,
  canManage,
}) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Categories ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search categories"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddCategory} disabled={!canManage}>
          + Create Category
        </Button>
      </div>
    </div>
  );
};

export default CategoriesHeader;
